var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"comingsoon-layout"}},[_c('div',{staticClass:"container-fluid main-content-container"},[_c('nuxt',{staticClass:"main-content-comingsoon",attrs:{"id":"page-content"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }